const carriersQueryKeys = {
    all: ['carriers'] as const,
    list: (accountId: string) => [...carriersQueryKeys.all, accountId, 'list'] as const,
    listMaster: () => [...carriersQueryKeys.all, 'master', 'list'] as const,
};

export default carriersQueryKeys;
